// extracted by mini-css-extract-plugin
export default {"benefits":"Benefits_benefits__vAtsW","benefits__title":"Benefits_benefits__title__KC5od","benefits__wrapper":"Benefits_benefits__wrapper__cgUaO"};